import { supabase } from '@/lib/supabase';

// ─────────────────────────────────────────────────────────────
// Suivi du bouton « Réserver » du site public.
// Deux types d'événements sont enregistrés dans `reserve_button_events` :
//   • "view"  → le visiteur voit le bouton Réserver (1 fois par session) ;
//   • "click" → le visiteur clique sur le bouton (appel).
// L'écriture est best-effort : elle ne doit jamais gêner la navigation.
// ─────────────────────────────────────────────────────────────

const TABLE = 'reserve_button_events';

function sessionId(): string {
  try {
    let id = sessionStorage.getItem('zifek_sid');
    if (!id) {
      id = `s_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
      sessionStorage.setItem('zifek_sid', id);
    }
    return id;
  } catch {
    return 'anon';
  }
}

/** Enregistre que le visiteur a vu le bouton Réserver (dédupliqué par session). */
export async function trackReserveView(boutiqueId: number): Promise<void> {
  if (!boutiqueId) return;
  const key = `zifek_reserve_view_${boutiqueId}`;
  try {
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, '1');
  } catch {
    /* stockage indisponible : on enregistre quand même (best-effort) */
  }
  try {
    await supabase.from(TABLE).insert({
      boutique_id: boutiqueId,
      session_id: sessionId(),
      event: 'view',
    });
  } catch {
    /* best-effort */
  }
}

/** Enregistre un appel (clic) sur le bouton Réserver. */
export async function trackReserveClick(boutiqueId: number): Promise<void> {
  if (!boutiqueId) return;
  try {
    await supabase.from(TABLE).insert({
      boutique_id: boutiqueId,
      session_id: sessionId(),
      event: 'click',
    });
  } catch {
    /* best-effort */
  }
}